import Bowser from 'bowser';

// Safely get the browser name using Bowser. Falls back to empty string when not in a browser.
export function getBrowserName(): string {
  try {
    if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined') {
      return Bowser.getParser(window.navigator.userAgent).getBrowserName();
    }
  } catch {
    // ignore
  }
  return '';
}

export function isInternetExplorer(): boolean {
  return getBrowserName() === 'Internet Explorer';
}

export function isEdgeBrowser(): boolean {
  return getBrowserName() === 'Microsoft Edge';
}

export function isSafariBrowser(): boolean {
  return getBrowserName() === 'Safari';
}

export function isChromeBrowser(): boolean {
  return getBrowserName() === 'Chrome';
}
